import {
    JOURNEY,
    GET_JOURNEY,
    GET_JOURNEY_TRAVELLED,
    GET_JOURNEY_TRAVELLED_BY_FILTER
} from "./type";

const initialState = {
    journeyDetails: [],
    getUserJourney: [],
    journeyTravelled: [],
    journeyTravelledByFilter: []
};

const Journey = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case JOURNEY:
            return {
                ...state,
                journeyDetails: payload,
            };
        case GET_JOURNEY:
            return {
                ...state,
                getUserJourney: payload,
            };
        case GET_JOURNEY_TRAVELLED:
            return {
                ...state,
                journeyTravelled: payload,
            };
        case GET_JOURNEY_TRAVELLED_BY_FILTER:
            return {
                ...state,
                journeyTravelledByFilter: payload,
            };
        default:
            return { ...state };
    }
};

export default Journey;